import React from 'react';
import { ReactComponent as CartSvg } from './svgs/cart.svg';
import { ReactComponent as ViolationReviewSvg } from './svgs/violationReviewSvg.svg';
import { ReactComponent as CourierSvg } from './svgs/courier.svg';
import { ReactComponent as LocationSvg } from './svgs/location.svg';
import { ReactComponent as OffLineSvg } from './svgs/offLine.svg';
import { ReactComponent as PackageSvg } from './svgs/package.svg';
import { ReactComponent as RegisterAvatarSvg } from './svgs/registerAvatar.svg';
import { ReactComponent as TaskSvg } from './svgs/task.svg';
import { ReactComponent as TaskWhiteSvg } from './svgs/taskWhite.svg';
import { ReactComponent as TransferInSvg } from './svgs/transferIn.svg';
import { ReactComponent as TransferOutSvg } from './svgs/transferOut.svg';
import { ReactComponent as WarehouseSvg } from './svgs/warehouse.svg';
import { ReactComponent as RedeliverySvg } from './svgs/redelivery.svg';
import { ReactComponent as MapModeSvg } from './svgs/mapmode.svg';
import { ReactComponent as DeliveredSvg } from './svgs/delivered.svg';
import { ReactComponent as DeliveryFailedSvg } from './svgs/deliveryFailed.svg';
import { ReactComponent as PackageSearchSvg } from './svgs/packageSearch.svg';
import { ReactComponent as PodDocumentSvg } from './svgs/podDocument.svg';
import { ReactComponent as SortingSvg } from './svgs/sorting.svg';
import { ReactComponent as DriverViolationSvg } from './svgs/driverViolation.svg';
import { ReactComponent as DeliveredParcelSvg } from './svgs/deliveredParcel.svg';
import { ReactComponent as LocationTargetSvg } from './svgs/location-target.svg';
import { ReactComponent as PinGraySvg } from './svgs/pin-gray.svg';
import { ReactComponent as UploadSvg } from './svgs/upload.svg';
import { ReactComponent as GooglePlaySvg } from './svgs/googlePlay.svg';
import { ReactComponent as AppStoreSvg } from './svgs/appStore.svg';

interface IconProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  color?: string;
  style?: React.CSSProperties;
}

export const CartIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <CartSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const ViolationReviewIcon: React.FC<IconProps> = ({
                                                width = 24,
                                                height = 24,
                                                className,
                                                color,
                                                style
                                              }) => {
  return (
      <ViolationReviewSvg
          width={width}
          height={height}
          className={className}
          fill={color}
          style={style}
      />
  );
};

export const CourierIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <CourierSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const LocationIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <LocationSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const OffLineIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <OffLineSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const PackageIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <PackageSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const RegisterAvatarIcon: React.FC<IconProps> = ({ 
  width = 80, 
  height = 80, 
  className,
  color,
  style 
}) => {
  return (
    <RegisterAvatarSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const TaskIcon: React.FC<IconProps> = ({ 
  width = 18, 
  height = 18, 
  className,
  color,
  style 
}) => {
  return (
    <TaskSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const TaskWhiteIcon: React.FC<IconProps> = ({ 
  width = 18, 
  height = 18, 
  className,
  color,
  style 
}) => {
  return (
    <TaskWhiteSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const TransferInIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <TransferInSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const TransferOutIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <TransferOutSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const WarehouseIcon: React.FC<IconProps> = ({ 
  width = 24, 
  height = 24, 
  className,
  color,
  style 
}) => {
  return (
    <WarehouseSvg 
      width={width} 
      height={height} 
      className={className}
      fill={color}
      style={style}
    />
  );
};

export const RedeliveryIcon: React.FC<IconProps> = ({
   width = 24,
   height = 24,
   className,
   color,
   style
 }) => {
  return (
      <RedeliverySvg
          width={width}
          height={height}
          className={className}
          fill={color}
          style={style}
      />
  );
};

export const MapModeIcon: React.FC<IconProps> = ({
   width = 24,
   height = 24,
   className,
   color,
   style
 }) => {
  return (
      <MapModeSvg
          width={width}
          height={height}
          className={className}
          fill={color}
          style={style}
      />
  );
};

export const DeliveredIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <DeliveredSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const DeliveryFailedIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <DeliveryFailedSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const DriverViolationIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <DriverViolationSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const PackageSearchIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <PackageSearchSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const PodDocumentIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <PodDocumentSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const SortingIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <SortingSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const DeliveredParcelIcon: React.FC<IconProps> = ({
                                                     width = 20,
                                                     height = 20,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <DeliveredParcelSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const LocationTargetIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className,
                                                     color,
                                                     style
                                                 }) => {
    return (
        <LocationTargetSvg
            width={width}
            height={height}
            className={className}
            fill={color}
            style={style}
        />
    );
};

export const PinGrayIcon: React.FC<IconProps> = ({
    width = 32,
    height = 45,
    className,
    style
}) => {
    return (
        <PinGraySvg
            width={width}
            height={height}
            className={className}
            style={style}
        />
    );
};

export const UploadIcon: React.FC<IconProps> = ({
                                                     width = 20,
                                                     height = 20,
                                                     className,
                                                     style
                                                 }) => {
    return (
        <UploadSvg
            width={width}
            height={height}
            className={className}
            style={style}
        />
    );
};

export const GooglePlayIcon: React.FC<IconProps> = ({
                                                     width = 32,
                                                     height = 45,
                                                     className,
                                                     style
                                                 }) => {
    return (
        <GooglePlaySvg
            width={width}
            height={height}
            className={className}
            style={style}
        />
    );
};

export const AppStoreIcon: React.FC<IconProps> = ({
                                                    width = 20,
                                                    height = 20,
                                                    className,
                                                    style
                                                }) => {
    return (
        <AppStoreSvg
            width={width}
            height={height}
            className={className}
            style={style}
        />
    );
};